// src/pages/MeetHarmonyNavigator.js
import React, { useRef, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import LivingHarmonyHeader from "../components/LivingHarmonyHeader";
import { useAuthWait } from "../auth";
import { getProfile } from "../api/ProfileOntologyManager.js";

const links = [
  { label: "Design with Harmony", file: "/" },
  { label: "New Project", file: "/new-project" },
  { label: "Design Studio", file: "/design" },
  { label: "Profile", file: "/profile" },
  { label: "Ontology", file: "/ontology" },
];

export default function MeetHarmonyNavigator() {
  const [awsCreds, setAwsCreds] = useState(null);
  const [profile, setProfile] = useState(null);
  const [userId, setUserId] = useState(null);

  // Centralize auth + profile fetch here
  const { user, loading } = useAuthWait(async (authedUser, creds) => {
    setAwsCreds(creds || null);

    if (!authedUser || !creds) {
      setProfile(null);
      return;
    }

    try {
      const userId = creds.identityId;

      setUserId(userId);
      const loaded = await getProfile(userId, creds);
      setProfile(loaded || null);
      console.log("Profile:", loaded);
    } catch (err) {
      console.error("[MeetHarmonyNavigator] Failed to load profile:", err);
      setProfile(null);
    }
  });

  const navigate = useNavigate();
  const location = useLocation();
  const listRef = useRef(null);

  const scrollBy = (offset) => {
    listRef.current?.scrollBy({ left: offset, behavior: "smooth" });
  };

  const handleSelect = (file) => navigate(file);

  // Optional: wire this up to your auth layer
  const handleLogout = () => {
    console.log("User logged out");
  };

  return (
    <>
      <LivingHarmonyHeader />

      <nav className="living-harmony-menu">
        <button
          className="slider-btn left"
          aria-label="Scroll left"
          onClick={() => scrollBy(-200)}
        >
          ◀
        </button>

        <ul className="slider-list" ref={listRef}>
          {links.map(({ label, file }) => (
            <li
              key={file}
              className={`slider-item ${location.pathname === file ? "selected" : ""}`}
              onClick={() => handleSelect(file)}
            >
              {label}
            </li>
          ))}
        </ul>

        <button
          className="slider-btn right"
          aria-label="Scroll right"
          onClick={() => scrollBy(200)}
        >
          ▶
        </button>
      </nav>

      <Outlet
        context={{
          userId,
          user,
          awsCreds,
          loading,
          profile, // children can read profile data directly
        }}
      />
    </>
  );
}
